// Tab "Người tham gia": người có ví Xu + tài khoản thử (lọc hạng, tìm tên/id, sắp xếp) → bấm dòng mở Drawer chi tiết.
import { useCallback, useEffect, useState } from "react";
import { Card, Input, Select, Table, Tag, message } from "antd";
import xuProgramApi from "../../../api/xuProgramApi";
import XuUserDrawer from "./xu-user-drawer";
import XuEmptyHint from "./xu-empty-hint";
import { apiError, fmtNum, fmtVnDate, tierColor, tierHex } from "./xu-format-helpers";

const SORTS = [
    { value: "balance", label: "Số dư Xu cao nhất" },
    { value: "tier", label: "Hạng cao nhất" },
    { value: "points90", label: "Điểm 90 ngày cao nhất" },
    { value: "lastCheckin", label: "Điểm danh gần nhất" },
];

export default function XuParticipantsTab({ openUserId, onOpenUser }) {
    const [state, setState] = useState({ items: [], total: 0, pageSize: 50, tiers: [] });
    const [loading, setLoading] = useState(false);
    const [q, setQ] = useState("");
    const [tier, setTier] = useState(undefined);
    const [sort, setSort] = useState("balance");
    const [page, setPage] = useState(1);
    const [beta, setBeta] = useState(false);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await xuProgramApi.listParticipants({ sort, tier, q: q.trim() || undefined, page, beta: beta ? 1 : undefined });
            setState(data.data);
        } catch (e) {
            message.error(apiError(e, "Không tải được danh sách"));
        } finally {
            setLoading(false);
        }
    }, [sort, tier, q, page, beta]);
    useEffect(() => {
        load();
    }, [load]);

    const tierName = (t) => state.tiers.find((x) => x.tier === t)?.name || `Hạng ${t}`;
    const columns = [
        { title: "Người dùng", fixed: "left", render: (_, r) => <span className="font-medium">{r.name || "(chưa đặt tên)"} <span className="text-gray-400 font-normal">#{r.userId}</span>{r.isBeta && <Tag color="purple" className="ml-2">Tài khoản thử</Tag>}</span> },
        { title: "Hạng", dataIndex: "tier", render: (t) => <Tag color={tierColor(t)} style={{ borderColor: tierHex(t) }}>{tierName(t)}</Tag> },
        { title: "Điểm 90 ngày", dataIndex: "points90", align: "right", render: (v) => `${fmtNum(v)}đ` },
        { title: "Số dư Xu", dataIndex: "balance", align: "right", render: (v) => <b>{fmtNum(v)}</b> },
        { title: "Chuỗi", dataIndex: "streak", align: "right", render: (v) => (v ? `${v} ngày` : "—") },
        { title: "Điểm danh gần nhất", dataIndex: "lastCheckin", render: fmtVnDate },
    ];
    const filtering = Boolean(q || tier || beta);

    return (
        <div className="space-y-3">
            <Card size="small" className="shadow-sm">
                <div className="flex flex-wrap items-center gap-2">
                    <Input.Search allowClear style={{ width: 240 }} placeholder="Tìm theo tên hoặc userId" onSearch={(v) => { setQ(v); setPage(1); }} />
                    <Select allowClear style={{ width: 160 }} placeholder="Lọc theo hạng" value={tier} onChange={(v) => { setTier(v); setPage(1); }}
                        options={state.tiers.map((t) => ({ value: t.tier, label: t.name }))} />
                    <Select style={{ width: 190 }} value={beta} onChange={(v) => { setBeta(v); setPage(1); }}
                        options={[{ value: false, label: "Tất cả người tham gia" }, { value: true, label: "Chỉ tài khoản thử" }]} />
                    <Select style={{ width: 200 }} value={sort} onChange={(v) => { setSort(v); setPage(1); }} options={SORTS} />
                    <Input.Search className="ml-auto" style={{ width: 300 }} enterButton="Mở hồ sơ" placeholder="Mở theo userId (kể cả chưa có ví)"
                        onSearch={(v) => /^\d+$/.test(v.trim()) ? onOpenUser(Number(v.trim())) : message.warning("userId phải là số")} />
                </div>
            </Card>
            <Card size="small" className="shadow-sm">
                <Table
                    size="small"
                    rowKey="userId"
                    columns={columns}
                    dataSource={state.items}
                    loading={loading}
                    scroll={{ x: "max-content" }}
                    locale={{ emptyText: filtering
                        ? <XuEmptyHint title="Không tìm thấy ai khớp bộ lọc" hint="Thử bỏ bớt bộ lọc, hoặc dùng ô “Mở hồ sơ” để mở thẳng theo userId." />
                        : <XuEmptyHint title="Chưa có ai tham gia chương trình Xu" hint="Ở đây hiện tài khoản thử và người đã điểm danh / nhận thưởng. Thêm tài khoản thử ở tab Cấu hình." /> }}
                    onRow={(r) => ({ onClick: () => onOpenUser(r.userId), style: { cursor: "pointer" } })}
                    pagination={{ current: page, pageSize: state.pageSize, total: state.total, showSizeChanger: false, onChange: setPage, showTotal: (t) => `${fmtNum(t)} người` }}
                />
            </Card>
            <XuUserDrawer userId={openUserId} onClose={() => onOpenUser(null)} onChanged={load} />
        </div>
    );
}
